# import { default as WebModule__Content } from 'models/modulor/web_module/content'
#
# export class CurrentTerm extends WebModule__Content
#   @defaults =
#     debug: false
#     name: 'CurrentTermModule'
#
#   @selector: ".current_term_module"
#
#   on_init: ->
#     console.log 'init' if @options.debug
#
# CurrentTerm.register()
